import { Button, Modal, Space, InputNumber } from "antd";
import React, { useState } from "react";
import { EditFilled } from "@ant-design/icons";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { Notification } from "../../Notification";

const initialState = null;

export const ColorConsumptionPopup = (props) => {
   const [isModalOpen, setIsModalOpen] = useState(initialState);
   const [consumption, setConsumption] = useState(initialState);

   const showModal = async () => {
      setIsModalOpen(true);
      setConsumption(props.consumption);
   };

   const handleCancel = () => {
      setIsModalOpen(false);
      setConsumption(initialState);
   };

   const updateData = async (e) => {
      e.preventDefault();
      const ref = doc(db, "krasuPaterins", props.id);
      await updateDoc(ref, {
         consumption: props.consumption,
      })
         .then(() => {
            setIsModalOpen(true);
            setConsumption(initialState);
            Notification("success", "Updated!", "Your data has been updated");
         })
         .then(() => {
            setIsModalOpen(false);
         })
         .catch((err) => {
            Notification("error", "Login Error", err.message);
         });
   };
   return (
      <>
         <Button size="small" type="primary" onClick={showModal}>
            <EditFilled />
         </Button>
         <Modal width={700} title={"Consumption for :" + props.title} open={isModalOpen} onOk={updateData} onCancel={handleCancel}>
            <Space>
               <InputNumber addonBefore="Consumption :" value={consumption} style={{ width: "100%" }} onChange={(value) => setConsumption(value)} />
            </Space>
         </Modal>
      </>
   );
};
